// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".svg-icon{width:1em;max-width:1em;height:1em}", "",{"version":3,"sources":["webpack://./client/modules/common/dumb/icon/icon.css"],"names":[],"mappings":"AAAA,UACC,SAAU,CACV,aAAc,CACd,UACD","sourcesContent":[".svg-icon {\n\twidth: 1em;\n\tmax-width: 1em;\n\theight: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
